import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, User } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useBcv } from '../context/BcvContext';
import { Badge } from './ui/badge';

export const Header = () => {
  const navigate = useNavigate();
  const { getCartCount } = useCart();
  const { rate, isLoading: bcvLoading } = useBcv();
  const cartCount = getCartCount();

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-card/80 backdrop-blur-lg">
      {/* BCV Rate Ticker */}
      {!bcvLoading && rate && (
        <div className="bg-[#111] border-b border-[#39FF14]/20 py-1 px-4">
          <div className="container mx-auto flex items-center justify-center gap-2">
            <span className="text-[10px] text-gray-400 uppercase tracking-widest font-bold">Tasa BCV</span>
            <span className="text-[10px] font-black text-[#39FF14]">
              1 USD = Bs. {rate.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
            <span className="text-[9px] text-gray-600">• Banco Central de Venezuela</span>
          </div>
        </div>
      )}
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center group"
          >
            <img 
              src="/logo.png" 
              alt="Inversiones FU Logo" 
              className="h-12 w-auto object-contain logo-neon-breathe rounded-full" 
            />
          </button>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            {/* Cart Button */}
            <button
              onClick={() => navigate('/cart')}
              className="relative flex items-center space-x-2 px-4 py-2 rounded-lg bg-secondary hover:bg-secondary/80 transition-smooth"
            >
              <ShoppingCart className="h-5 w-5 text-foreground" />
              {cartCount > 0 && (
                <Badge
                  variant="default"
                  className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 bg-primary text-primary-foreground glow-neon text-xs font-bold"
                >
                  {cartCount}
                </Badge>
              )}
              <span className="hidden sm:inline text-sm font-medium">Carrito</span>
            </button>

            {/* Admin Button */}
            <button
              onClick={() => navigate('/admin/login')}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-muted/50 hover:bg-muted transition-smooth"
            >
              <User className="h-5 w-5 text-muted-foreground" />
              <span className="hidden sm:inline text-sm font-medium text-muted-foreground">Admin</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
